// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"24":"19a79fa07f7d1f36917b","108":"9e2472a7cf17ad6931e8","238":"d07b687c675495778bf4","670":"b11c0f6eb05729796e29","937":"35f7a0d9d6f0d26ff229","974":"9ed60d6237d59865d5d2"}[chunkId] + ".js";
};